module.exports = __webpack_public_path__ + "img/section2Logo3.29c0ea0a.svg";